import { Plugin } from '@ckeditor/ckeditor5-core';

export default class DynamicNameEditing extends Plugin {
	init() {
		this._defineSchema();
		this._defineConverters();
	}

	_defineSchema() {
		const schema = this.editor.model.schema;

		schema.extend('$text', {
			allowAttributes: [],
		});
	}

	_defineConverters() {
		const conversion = this.editor.conversion;

		conversion.for('downcast').attributeToElement({
			model: 'dynamicname',
			view: null,
		});
	}
}

